interface CustomInputProps {
  type: string;
  name: string;
  value: string;
  tailwindClasses?: string;
  isError: boolean | undefined;
  isTouched: boolean | undefined;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  maxLength?: number;
  placeholder: string;
}

export function CustomInput({
  type,
  name,
  value,
  tailwindClasses,
  isError,
  isTouched,
  onChange,
  maxLength,
  placeholder,
}: CustomInputProps) {
  return (
    <input
      type={type}
      name={name}
      value={value}
      className={`${tailwindClasses} block w-full appearance-none rounded-sm px-1 text-black focus:outline-none ${
        isError && isTouched ? 'border-[3px] border-rose-500' : ''
      }`}
      onChange={onChange}
      maxLength={maxLength}
      placeholder={placeholder}
    />
  );
}
